// The one place the diagnostics palette is defined.
//
// These values were copy-pasted into every component that needed them, which
// worked until the QA asked for the small grey text to be darkened: five files
// were updated and two were missed, so MUTED ended up meaning three different
// colours at once and two screens still showed the text she had complained
// about. A shared object makes the next request one edit.
//
// Plain constants rather than CSS variables or a theme provider: these
// components render inside the existing Bootstrap pages, which already carry a
// global stylesheet, and adding a second cascade for one feature is how the two
// end up fighting.

export const BMD_COLOURS = {
  /** Headings and any figure the tutor is meant to read first. */
  INK: "#1f2a44",
  /** Body text and secondary figures. */
  BODY: "#47597c",
  /** Labels, helper lines, units. Darkened from #8a97b1 at the PM's request. */
  MUTED: "#5f7191",
  /** The one call to action. */
  ACCENT: "#c62644",

  /** Hairline between rows. Two near-identical greys existed; both kept. */
  RULE: "#eceff5",
  /** Slightly warmer hairline used on card edges. */
  CARD_BORDER: "#e9edf3",
  /** Tinted band behind a section header. */
  SECTION_BG: "#eef2f8",
  /** Row highlight when a row is picked. */
  SELECTED_ROW_BG: "#f5f8fd",
} as const

// KNOWN DIVERGENCES, left alone on purpose rather than quietly restyled.
//
// Two components still declare their own values. Both are on screens the QA is
// reviewing right now, so changing how they look as part of a tidy-up would
// muddy her feedback. Fold them in once she has signed those screens off:
//
//   BmdMasteryBreakdownTab  INK #16264a, MUTED #7d8aa3, BODY #5a6b8c
//   BmdStrandPicker         BODY #5a6b8c, MUTED #8a97b1  <- the faint one
//
// BmdDashboardTabs is NOT a divergence: it draws the dark tab strip, where
// ACCENT #ff5a5a is the colour that reads against a navy background.
